import React, { useState, useEffect } from 'react';
import { useDispatch, useSelector} from 'react-redux'
import { lighten, makeStyles, useTheme } from '@material-ui/core/styles';
import { Button, TextField, Divider, Tooltip, Fab, Box } from '@material-ui/core';
import { green } from '@material-ui/core/colors';
import ViewHeadlineIcon from '@material-ui/icons/ViewHeadline';
import EqualizerIcon from '@material-ui/icons/Equalizer';
import CloudDownloadIcon from '@material-ui/icons/CloudDownload';
import ExpandMoreIcon from '@material-ui/icons/ExpandMore';
import PlayCircleFilledIcon from '@material-ui/icons/PlayCircleFilled';
import BuildIcon from '@material-ui/icons/Build';
import ExportJsonExcel from 'js-export-excel';
import { useTranslation } from 'react-i18next';
import moment from 'moment';
import i18n from 'i18next';

import ChooseColumnDialog from '../ChooseColumnDialog';
import StaticsDialog from '../StaticsDialog';
import ShortcutActionDialog from '../ShortcutActionDialog';
import SelectedDrawer from '../SelectedDrawer';

import { getNextOperations, batchUpdateCargoTracking } from '../../../actions/batchManagementActions';
import { showAlertSnackbar } from '../../../reducers/uiSlice';


const useStyles = makeStyles((theme) => ({
    root: {
      width: '100%',
    },
    paper: {
      width: '100%',
      marginBottom: theme.spacing(2),
    },
    moreAction: {
        width: 350
    },
    shortCutMenu: {
        width: 350
    },    
    heading: {
        fontSize: theme.typography.pxToRem(15),
        fontWeight: theme.typography.fontWeightRegular,
      },    
    table: {
      minWidth: 750,
    },
    visuallyHidden: {
      border: 0,
      clip: 'rect(0 0 0 0)',
      height: 1,
      margin: -1,
      overflow: 'hidden',
      padding: 0,
      position: 'absolute',
      top: 20,
      width: 1,
    },
    iconButton: {
        color: green[500],
        width: 40, 
        height: 40, 
        marginTop: 0,
        marginRight: 20,
    },
  }));

export default function Toolsbar(props) {
    const { isDisabled, headCellState, rows, warehouse, selectedDispatchNo, allWarehouseModel } = props;    
    
    const classes = useStyles();
    const {t} = useTranslation('batchManagement');
    const dispatch = useDispatch();

    const TRANSITION_OPTION_PLS_SELECT = 'OPTION_TRANSITION_PLS_SELECT';
    const TO_STATE_OPTION_PLS_SELECT = 'Pls select';
    const TO_TRANSLATION_OPTION_PLS_SELECT = '请选择';
    const TRANSITION_NOT_SAME_STATE = 'OPTION_TRANSITION_NOT_SAME_STATE';
    const TO_STATE_NOT_SAME_STATE = 'invaild: state not same';
    const TO_TRANSLATION_NOT_SAME_STATE = '无效：状态不一致';
    const TO_CODE_INVAILD = -1;

    //const nextStepList = useSelector(state => state.batchManagement.nextStepList) || [];

    const [isOpenChooseColumnsDialog, setIsOpenChooseColumnsDialog] = useState(false);
    const [isOpenStaticsDialog, setIsOpenStaticsDialog] = useState(false);
    const [isOpenShortcutActionDialog, setIsOpenShortcutActionDialog] = useState(false);
    const [stateNextStep,setStateNextStep] = useState();
    const [stateNextStepList,setStateNextStepList] = useState([]);
    const [isShowSelectedDrawer,setIsShowSelectedDrawer] = useState(false);

    useEffect(() => {
        if (selectedDispatchNo.filter((item)=>item.selected).length > 0) {
            let result = checkSelectedSameState(selectedDispatchNo);            
            if (result.sameState === false) {
                setStateNextStepList([{'transition': TRANSITION_NOT_SAME_STATE, 
                    'to_state': TO_STATE_NOT_SAME_STATE,
                    'to_translation': TO_TRANSLATION_NOT_SAME_STATE, 
                    'to_code': TO_CODE_INVAILD}]);
            } else {
                dispatch(getNextOperations(result.fromState)).then(nextStepList=>{
                    if (nextStepList.length > 0) {
                        let [...arr] = nextStepList;
                        arr.unshift({'transition': TRANSITION_OPTION_PLS_SELECT, 
                            'to_state': TO_STATE_OPTION_PLS_SELECT,
                            'to_translation': TO_TRANSLATION_OPTION_PLS_SELECT,
                            'to_code': TO_CODE_INVAILD,
                        });            
                        setStateNextStepList(arr);
                    }            
                });
            }
        }
    }, [selectedDispatchNo]);  

    // useEffect(() => {
    //     if (nextStepList.length > 0) {
    //         let [...arr] = nextStepList;
    //         arr.unshift({'transition': TRANSITION_OPTION_PLS_SELECT, 
    //             'to_state': TO_STATE_OPTION_PLS_SELECT,
    //             'to_translation': TO_TRANSLATION_OPTION_PLS_SELECT,
    //             'to_code': TO_CODE_INVAILD,
    //         });            
    //         console.log("*************Toolsbar nextStepList: ",nextStepList);
    //         setStateNextStepList(arr);
    //     }
    // }, [nextStepList]);  

    return (
        // <div style={{display: 'flex', flexDirection: 'row', padding: 16}}>
        <div style={{ display: 'flex', flexDirection: 'row'}}>
            <div style={{ display: 'flex', flexDirection: 'row'}}>
                <TextField 
                    id="stateNextStep"
                    select
                    SelectProps={{ native: true }}  
                    label={t('label_next_step')}
                    InputLabelProps={{ shrink: true }}                
                    variant="outlined"
                    value={stateNextStep}
                    onChange={(e) => {
                        setStateNextStep(e.target.value);
                    }}                
                    style={{width: 200, paddingRight: 16}}      
                    disabled={isDisabled}                  
                >
                { stateNextStepList
                    ? 
                    stateNextStepList.map((item,index) => (
                        <option key={item.transition + index} 
                                value={ item.transition }
                        >
                            { i18n.language.includes("en") ? item.to_state : item.to_translation }
                        </option>
                    ))
                    :
                    null
                }                
                </TextField>   
                <Tooltip title={t('button_execute')} aria-label='execute' >
                    <Fab className={classes.iconButton} disabled={isDisabled || rows.length === 0}>
                        <PlayCircleFilledIcon onClick={handleNextStep} ></PlayCircleFilledIcon>
                    </Fab>
                </Tooltip>
            </div>            
            <Divider orientation="vertical" flexItem />                         
            <div style={{ display: 'flex', flexDirection: 'row', paddingLeft: 16}}>
                <Tooltip title={t('button_operate_shortcut')} aria-label='operate shortcut'>
                    <Fab className={classes.iconButton} style={{paddingLeft: 16}} disabled={isDisabled}>
                        <BuildIcon style={{marginLeft: -16}} onClick={handleOpenShortcutActionDialog} ></BuildIcon>
                    </Fab>
                </Tooltip>                                
                { isOpenShortcutActionDialog
                ?
                //<ShortcutActionDialog openModal={isOpenShortcutActionDialog} onClose={handleCloseShortcutActionDialog}/>
                <ShortcutActionDialog openModal={isOpenShortcutActionDialog} onClose={handleCloseShortcutActionDialog} warehouse={warehouse} selectedDispatchNo={selectedDispatchNo} rows={rows}/>
                :
                null
                }
                <Tooltip title={t('button_show_column')} aria-label='show column' >
                    <Fab className={classes.iconButton} >
                        <ViewHeadlineIcon onClick={handleOpenChooseColumnsDialog} ></ViewHeadlineIcon>
                    </Fab>
                </Tooltip>                 
                { isOpenChooseColumnsDialog 
                    ?
                    <ChooseColumnDialog openModal={isOpenChooseColumnsDialog}  onClose={handleCloseChooseColumnsDialog}/>
                    :
                    null
                }            
                <Tooltip title={t('button_statistics_status')} aria-label='statistics status' >
                    <Fab className={classes.iconButton} disabled={isDisabled || rows.length === 0}>
                        <EqualizerIcon onClick={handleOpenStaticsDialog} ></EqualizerIcon>
                    </Fab>
                </Tooltip>                  
                { isOpenStaticsDialog
                    ?
                    <StaticsDialog openModal={isOpenStaticsDialog}  onClose={handleCloseStaticsDialog}/>
                    :
                    null
                }
                <Tooltip title={t('button_download')} aria-label='download' >
                    <Fab className={classes.iconButton} disabled={isDisabled || rows.length === 0}>
                        <CloudDownloadIcon onClick={handleDownload} ></CloudDownloadIcon>
                    </Fab>
                </Tooltip>                   
            </div>    
        </div>    
    )



/**
 * create an choose columns dialog
 */
 function handleOpenChooseColumnsDialog() {
    setIsOpenChooseColumnsDialog(true);
 }

 /**
  * close the choose columns dialog
  */
function handleCloseChooseColumnsDialog() {
    setIsOpenChooseColumnsDialog(false);
}

/**
 * open statics dialog
 */
function handleOpenStaticsDialog() {
    setIsOpenStaticsDialog(true);
}

/**
 * close statics dialog
 */
function handleCloseStaticsDialog() {
    setIsOpenStaticsDialog(false);
}

/**
 * open statics dialog
 */
 function handleOpenShortcutActionDialog() {
    //setIsOpenShortcutActionDialog(true);
    setIsOpenShortcutActionDialog(!isOpenShortcutActionDialog);
}

/**
 * close statics dialog
 */
function handleCloseShortcutActionDialog() {
    setIsOpenShortcutActionDialog(false);
}

/**
 * export the data to excel
 */
function handleDownload() {
    var option={};
    let dataTable = [];
    
    //let headCells = JSON.parse(localStorage.getItem("head_cells") || '[]').filter((item)=>(item.checked)) || [];
    let sheetFilterArr = [];
    let sheetHeaderArr = [];
    for (let i = 0; i < headCellState.length; i++) {
        if (headCellState[i].checked) {
            sheetFilterArr.push(headCellState[i].id);
            sheetHeaderArr.push(t(headCellState[i].label));
        }
    }

    rows.map((row,index)=>{
        let rowMap = new Map();
        headCellState.map((item,idx)=>{
            if (item.checked) {
                rowMap.set(item.id, (item.format === 'date') 
                                    ? 
                                    moment.unix(row[item.id]).format("YYYY-MM-DD hh:mm:ss") 
                                    : (item.format === 'percent') ? (row[item.id] * 100).toFixed(2) + "%" : row[item.id]
                );
            }                
        })
        if (rowMap.size > 0) {
            dataTable.push(JSON.parse(MapTOJson(rowMap)));
        }
    });

   
    option.fileName = t('download_file_name');
    option.datas=[
        {
            sheetData:dataTable,
            sheetName:'sheet',
            sheetFilter:sheetFilterArr,
            sheetHeader:sheetHeaderArr,
        }
    ];

    let toExcel = new ExportJsonExcel(option);
    toExcel.saveExcel();            
}


/**
 * utils convert map to json obj str
 * @param {} m 
 * @returns 
 */
function MapTOJson(m) {
    var str = '{';
    var i = 1;
    m.forEach(function (item, key, mapObj) {
    	if(mapObj.size === i){
    		str += '"'+ key+'":"'+ item + '"';
    	}else{
    		str += '"'+ key+'":"'+ item + '",';
    	}
    	i++;
    });
    str +='}';
    return str;
}

  /**
   * check if there's state step difference if there's the "next step " shoule be unavailable
   * 1. selected and in same dispatch group , there's different state of the master_air_way_bill 
   * 2. selectd there's different state of the dispatch 
   * 
   * @param {*} selectedOptions 
   * @returns 
   */
  
   function checkSelectedSameState(selectedOptions) {
    let selectedTrueDispthNo = selectedOptions.filter((options)=>(options.selected === true));

    // Save first prevStatSteps and loop when all warehouses selected
    let prevStatStepsAll = "";

    let fromState = "";
    for (let i = 0; i < selectedTrueDispthNo.length ; i++) {
        let selectedTrueMawb = selectedTrueDispthNo[i].mawb.filter((item)=>item.selected);
        //get the stat steps of the first mastr_air_way_bill
        let prevStatSteps = "";
        for (let k = 0; k < selectedTrueMawb[0].tracking.length;k++) {
            prevStatSteps += selectedTrueMawb[0].tracking[k].state;

            // the last one is the available from state
            if (k === selectedTrueMawb[0].tracking.length - 1) {
                fromState = selectedTrueMawb[0].tracking[k].state;
            }
                
        }

        // Select all warehouses and compare states between branches
        if(i===0 && allWarehouseModel) {
            prevStatStepsAll = prevStatSteps;
        }
        if(i!==0 && allWarehouseModel) {
            if(prevStatStepsAll !== prevStatSteps) {
                return {'sameState': false,'fromState': fromState};
            }
        }

        //get the stat steps of the following mastr_air_way_bill
        for (let j = 1; j < selectedTrueMawb.length; j++) {
            let curStatSteps = "";
            for (let k = 0; k < selectedTrueMawb[j].tracking.length;k++) {
                curStatSteps += selectedTrueMawb[j].tracking[k].state;
            }
            // the stat steps of the master_air_way_bill which belong to same dispatch_no is not the same
            // alter the message
            if (prevStatSteps !== curStatSteps) {
                return {'sameState': false,'fromState': fromState};
            }
            // Select all warehouses and compare states between and within branches
            if(allWarehouseModel) {
                if(prevStatStepsAll !== prevStatSteps) {
                    return {'sameState': false,'fromState': fromState};
                }
            }
        }                
    }            
    return {'sameState': true,'fromState': fromState};
  }


  /**
   * read the search SN from local storage
   * open the SearchSN history List, max length is 8
   */
   function handleToggleDrawer(open,event) {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }

    if (isShowSelectedDrawer !== open) {
        setIsShowSelectedDrawer(open);
    }

  } 

  /**
   * control the SearchSN history List, max length is 8
   */
  function toggleDrawer(open,event) {
    if (event.type === 'keydown' && (event.key === 'Tab' || event.key === 'Shift')) {
        return;
      }

    if (isShowSelectedDrawer !== open) {
        setIsShowSelectedDrawer(open)
    }
  } 

  /**
   * excute from the previous state to next state
   */
  function handleNextStep() {
    if (!stateNextStep || stateNextStep === TRANSITION_OPTION_PLS_SELECT || stateNextStep === TRANSITION_NOT_SAME_STATE) {
        dispatch(showAlertSnackbar({type: "info", message: "pls choose the vaild next state!"}));
        return;
    }

    let selectedTrueMawb = [];
    let selectedTrueDispthNo = selectedDispatchNo.filter((options)=>(options.selected === true));
    for (let i = 0; i <  selectedTrueDispthNo.length ; i++) {
        [...selectedTrueMawb] = selectedTrueDispthNo[i].mawb.filter((item)=>item.selected).map((ele,idx)=>ele.master_air_waybill);
    }

    
    let nextStepObj = stateNextStepList.filter((item)=>item.transition === stateNextStep)[0];
    
    let params = {
        'master_air_waybills': selectedTrueMawb,
        'warehouse': warehouse ,
        'transition': nextStepObj.transition,
        'state': nextStepObj.to_code,
        'is_init': 1,       //by default
    }
    
    dispatch(batchUpdateCargoTracking(params));

  }

}